module.exports = __webpack_public_path__ + "static/media/huoying.4043d75f.png";